/**
 * Remove the 'https' from the given url
 * @param {string} url
 */
export const stripUrl = (url: string) =>
  url
    // .replace(/^https?:/, '') // Component Image not working with https
    ?.split('vteximg.com.br')
    ?.join('vtexassets.com')

/**
 * Ensure the given Decathlon URL uses HTTPS to prevent mixed content issues.
 * URLs coming from CMS or DY may contain http:// — this sanitizes them.
 * @param {string} url
 */
export const ensureHttps = (url: string): string => {
  if (!url) return url

  return url.replace(
    /^http:\/\/www\.decathlon\.com\.br/,
    'https://www.decathlon.com.br'
  )
}
